import type { EmailRecipient } from 'components/RichTextEditor/types';
import type { ManageTicketFieldData } from 'containers/Ticketing/hooks/useManageTicket/types';

export enum PlatformType {
  ALL = 'all', // all messages
  APP = 'app', // internal notes message
  EMAIL = 'email', // email message
  SLACK = 'slack', // slack message
  WORKFLOW = 'workflow', // message created via workflow

  // created through AIA
  CHATBOT = 'chatbot',
  CHATBOT_EMAIL = 'chatbot_email',
  CHATBOT_SLACK = 'chatbot_slack',
  COMMENT = 'comment', // ticket comment (rendered separately in comments tab)
  IRONCLAD = 'ironclad', // ironclad comment
}

export interface CreateMessageParams {
  platformType: PlatformType;
  body: string;
  metadata: {
    recipients: EmailRecipient[];
    cc?: EmailRecipient[];
  };
}

export interface AttachmentRequest {
  s3Id: string;
  fileName: string;
}

export interface CreateNewTicketParams {
  subject: string;
  fields?: ManageTicketFieldData | null;
  message?: CreateMessageParams;
  attachments?: AttachmentRequest[];
}
